require('./cmWalletBuyStep1.scss');
const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const CmIntervenerList = require('../../cmIntervener/cmIntervenerList/cmIntervenerList');
const { LoadingSection } = require('commonsComponents/loadingSection');
const {
    OneLineSymbolAmount,
} = require('commonsComponents/oneLineSymbolAmount');
const CmFundsSummary = require('../../cmFundsSummary/step1/cmFundsSummaryStep1');
const CmTransferOriginContractsSummary = require('../../cmTransferOriginContractsSummary/cmTransferOriginContractsSummary');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @ commons
const { AmountInput } = require('commonsComponents/amountInput');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
const { getCurrentAccounts } = require('utilities/currentAccountsHelper.js');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { recordProcess, PROC_BUY_GDI, PROC_STEP } = require('utilities/tagging');
const { getLastNChars } = require('utilities/stringHelper');
const {
    buildAbsoluteFormattedValue,
} = require('wealth-cm/utilities/formatValueHelper');
const { sortBy } = require('lodash/collection');

// @ constants
const {
    CM_WIZARD_FIRST_STEP,
    CM_API_CENTER,
    CM_API_ENTERPRISE_NUMBER,
    CM_STEP1_AMOUNT_MIN,
    CM_STEP1_AMOUNT_MAX,
    CM_BUY_TYPE_TRANSFER,
    CM_BUY_TYPE_MONEY,
    CM_FILTERS_ALL_OPTIONS_VALUE,
} = require('wealth-cm/constants/constants');
const {
    DIVERSIFIED_INVESTMENT_FUNDTRANSFER,
} = require('constants/flagBasedFeatures');

class CmWalletBuyStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.buildIntervenerList = this.buildIntervenerList.bind(this);
        this.setAmount = this.setAmount.bind(this);
        this.buildFundsAmountWarning = this.buildFundsAmountWarning.bind(this);
        this.handleFromOtherFundsClick = this.handleFromOtherFundsClick.bind(
            this,
        );
        this.getBuyTypeButtonClass = this.getBuyTypeButtonClass.bind(this);
        this.onHandleWithMoneyClick = this.onHandleWithMoneyClick.bind(this);
        this.handleFilterFundsByAccount = this.handleFilterFundsByAccount.bind(
            this,
        );
        this.handleWalletChange = this.handleWalletChange.bind(this);
    }

    componentDidMount() {
        const { immCmWalletBuy } = this.props;
        const amount = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'amount',
        ]);

        if (!amount) {
            const amount = parseFloat(
                immCmWalletBuy.getIn(['simulation', 'amount']),
            );
            this.props.onSetInitialAmount(amount);
        }
        const eventTag = immCmWalletBuy.get('eventTag');
        recordProcess(PROC_BUY_GDI, PROC_STEP + 1, { processDetail: eventTag });
    }

    handleAccountChange(accountId) {
        const { immAccounts } = this.props;
        if (accountId) {
            const selectedAccount = immAccounts.getIn(['byId', accountId]);
            const accountAmount = selectedAccount.getIn([
                'balances',
                'availableBalance',
                'amount',
            ]);
            const contractNumber = selectedAccount.get('newContractNumber');
            const productNumber = selectedAccount.get('newProduct');
            const oldFullContractNumber = selectedAccount.getIn([
                'ibanComplex',
                'codbban',
            ]);
            this.props.onAccountChange(
                accountId,
                accountAmount,
                contractNumber,
                productNumber,
                oldFullContractNumber,
            );
        }
    }

    handleWalletChange(e) {
        this.props.onWalletChange(e.value);
    }

    setAmount(amount) {
        const { immCmWalletBuy } = this.props;
        const previousAmount = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'amount',
        ]);

        if (amount !== previousAmount) {
            const portfolioId = immCmWalletBuy.getIn(['simulation', 'id']);
            const publicAmount = immCmWalletBuy.getIn([
                'simulation',
                'publicAmount',
            ]);
            this.props.onSetAmount(amount);
            this.props.getPortfolioInfo(amount, portfolioId, publicAmount, this.props.history);

            if (amount === 0) {
                this.props.setBuyType(CM_BUY_TYPE_MONEY);
            }
        }
    }

    buildIntervenerList() {
        const {
            immCmWalletBuy,
            immAccounts,
            removeIntervener,
            restoreDefaultInterveners,
            setIntervenerType,
            setIntervenerName,
            addIntervener,
        } = this.props;
        const interveners = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'interveners',
        ]);
        if (!interveners.isEmpty()) {
            return (
                <div>
                    <CmIntervenerList
                        immStocksContractForm={immCmWalletBuy}
                        immAccounts={immAccounts}
                        setIntervenerName={setIntervenerName}
                        setIntervenerType={setIntervenerType}
                        addIntervener={addIntervener}
                        removeIntervener={removeIntervener}
                        restoreDefaultInterveners={restoreDefaultInterveners}
                        intervernersListTitle={'brokerCM-buyStep1Interveners'}
                        showTitleTooltip={false}
                        allowSetIntervenerName={true}
                    />
                </div>
            );
        }
    }

    buildDetailsLabel(immAccount) {
        if (immAccount) {
            const contractNumber = immAccount.get('newContractNumber') || '';
            const productNumber = immAccount.get('newProduct') || '';
            const owner = immAccount.get('accountHolder') || '';
            const contract = `${CM_API_ENTERPRISE_NUMBER} ${CM_API_CENTER} ${productNumber}${contractNumber}`;
            const contractLabel = formatText('brokerCM-buyStep1Contract');
            const holder = formatText('brokerCM-buyStep1Holder');
            return `${contractLabel}${contract} | ${holder}${toCamelCase(
                owner,
            )}`;
        }
    }

    buildAccountContainer() {
        const { immAccounts, immCmWalletBuy } = this.props;

        if (immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY) {
            if (!immAccounts.get('isFetching')) {
                const accountsText = formatText('brokerCM-buyStep1Accounts');
                const dropdownLabel = formatText('brokerCM-buyStep1CcTitle');
                const accountIsValid = immCmWalletBuy.getIn([
                    'steps',
                    CM_WIZARD_FIRST_STEP,
                    'accountIsValid',
                ]);
                const accountSelected = immCmWalletBuy.getIn([
                    'steps',
                    CM_WIZARD_FIRST_STEP,
                    'accountNumber',
                ]);
                const immAccount = immAccounts.getIn(['byId', accountSelected]);
                const detailsLabel = this.buildDetailsLabel(immAccount);
                const intervenerList = this.buildIntervenerList();
                const accountBalanceInvalid =
                    immAccounts.getIn([
                        'byId',
                        accountSelected,
                        'balances',
                        'availableBalance',
                        'amount',
                    ]) <= 0;
                const errorMessageKey = accountBalanceInvalid
                    ? 'brokerCM-buyStep1BalanceError'
                    : 'brokerCM-buyStep1AccountError';
                const errorMessage = formatText(errorMessageKey);
                const errorState =
                    (!accountIsValid && accountSelected === '') ||
                    accountBalanceInvalid;
                const accountsById = immAccounts.get('byId');
                const validAccountsById = accountsById.filter(account =>
                    account.getIn(['filters', 'valid']),
                );
                const accountsIndexes = getCurrentAccounts(
                    immAccounts.get('byOrder').toJS(),
                    validAccountsById,
                );
                const blockedAccountsIds = immAccounts.get(
                    'blockedAccountsIds',
                );
                const isBlockedAccountsLoading = immAccounts.get(
                    'blockedAccountsLoading',
                );

                return (
                    <div className="cm-buy-step1__account-container col-xs-12">
                        <section className="cm-buy-step1__associated-cc">
                            <label className="cm-buy-step1__associated-cc-label-subtitle">
                                {accountsText}
                            </label>

                            <div className="cm-buy-step1__associated-cc-stocks-contracts">
                                <DropdownAccounts
                                    id="broker-stocks-contracts"
                                    label={dropdownLabel}
                                    immAccounts={validAccountsById}
                                    blockedAccountsIds={blockedAccountsIds}
                                    accountsIndexes={accountsIndexes}
                                    currentAccountId={accountSelected}
                                    onAccountChange={this.handleAccountChange}
                                    error={errorState}
                                    errorMsg={errorMessage}
                                    showAvailableBalance
                                    detailsLabel={detailsLabel}
                                    loading={isBlockedAccountsLoading}
                                />
                            </div>
                        </section>
                        <section className="cm-buy-step1__interveners">
                            {intervenerList}
                        </section>
                    </div>
                );
            } else {
                return <LoadingSection />;
            }
        }
    }

    buildInput() {
        const { immCmWalletBuy } = this.props;
        const amount = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'amount',
        ]);
        const amountDirty = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'amountDirty',
        ]);
        const amountAccountIsValid = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'amountAccountIsValid',
        ]);

        const isMinFundAmountValid = immCmWalletBuy.get('isMinFundAmountValid');
        const showGeneralMinAmountMessage = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'showGeneralMinAmountMessage',
        ]);
        const emptyAmount = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'emptyAmount',
        ]);
        const customMinimumPurchaseAmount = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'investmentFunds',
            'customMinimumPurchaseAmount',
        ]);
        const isFetchingPortfolioInfo = immCmWalletBuy.get(
            'isFetchingPortfolioInfo',
        );
        let content;

        const mustDisplayMinimumAmountLabel = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'mustDisplayMinimumAmountLabel',
        ]);
        let injectedStrings;
        let minimumMessage;
        let errorState;

        if (emptyAmount) {
            injectedStrings = formatText('brokerCM-buyStep1AmountEmptyError');
        } else if (!amountAccountIsValid) {
            injectedStrings = formatText('brokerCM-buyStep1AmountError');
        } else if (!isMinFundAmountValid) {
            injectedStrings = '';
        }
        errorState =
            emptyAmount ||
            !amountAccountIsValid ||
            (!isMinFundAmountValid &&
                showGeneralMinAmountMessage &&
                !isFetchingPortfolioInfo);

        if (errorState && !amountDirty) {
            scrollToTop();
        }

        if (mustDisplayMinimumAmountLabel) {
            minimumMessage = (
                <div className="cm-buy-step1__associated-cc-minimal">
                    <FormattedText value="brokerCM-buyStep1Minimal" />
                    <OneLineSymbolAmount
                        amountObject={customMinimumPurchaseAmount}
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(
                            customMinimumPurchaseAmount,
                            true,
                        )}
                    />
                </div>
            );
        }
        const language = getLanguage();
        content = (
            <div className="cm-buy-step1__input-container">
                <div className="cm-buy-step1__amount-label">
                    <div className="cm-buy-step1__inner-input-container">
                        <FormattedText
                            value="brokerCM-buyStep1Amount"
                            className="cm-buy-step1__associated-cc-amount"
                        />
                    </div>
                </div>
                <AmountInput
                    amount={amount}
                    callback={this.setAmount}
                    error={
                        errorState && (!amountDirty || !isMinFundAmountValid)
                    }
                    errorMsg={injectedStrings}
                    hideFocusZero={true}
                    min={CM_STEP1_AMOUNT_MIN}
                    max={CM_STEP1_AMOUNT_MAX}
                    language={language}
                />

                <FormattedText
                    value="brokerCM-buyStep1AmountCurrencyLabel"
                    className="cm-buy-step1__associated-cc-amount-currency"
                />
                {minimumMessage}
            </div>
        );

        return content;
    }

    buildFundsDetails(
        portfolio,
        showGeneralMinAmountMessage,
        isFetchingPortfolioInfo,
    ) {
        const { immCmWalletBuy } = this.props;

        const inputContainer = this.buildInput();
        const minFundsAmountWarning = this.buildFundsAmountWarning(
            immCmWalletBuy,
        );

        return (
            <div className="cm-buy-step1__funds-details-box">
                <div className="cm-buy-step1__funds-summary-wrapper">
                    {inputContainer}
                    {minFundsAmountWarning}
                    <div className="cm-buy-step1__subtitle">
                        <FormattedText value="brokerCM-buyStep1WalletFundsDetails" />
                    </div>
                    <CmFundsSummary
                        portfolio={portfolio}
                        onLegalDocumentClick={this.props.onLegalDocumentClick}
                        showGeneralMinAmountMessage={
                            showGeneralMinAmountMessage
                        }
                        isFetchingPortfolioInfo={isFetchingPortfolioInfo}
                        hideDocument={true}
                        isFundsLink={true}
                    />
                </div>
            </div>
        );
    }

    buildFundsAmountWarning() {
        const { immCmWalletBuy } = this.props;
        const emptyAmount = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'emptyAmount',
        ]);
        const amountAccountIsValid = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'amountAccountIsValid',
        ]);
        const validAmountFund = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'validAmountFund',
        ]);
        const showGeneralMinAmountMessage = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'showGeneralMinAmountMessage',
        ]);
        const isFetchingPortfolioInfo = immCmWalletBuy.get(
            'isFetchingPortfolioInfo',
        );

        if (
            !immCmWalletBuy.get('isMinFundAmountValid') &&
            !emptyAmount &&
            amountAccountIsValid &&
            validAmountFund &&
            showGeneralMinAmountMessage &&
            !isFetchingPortfolioInfo
        ) {
            return (
                <div className="row cm-buy-step1__fund-min-amount">
                    <FormattedText value="brokerCM-buyStep1MinFundAmountError" />
                </div>
            );
        }
    }

    buildFundTransferWarning(filteredFundsInfoEmpty) {
        const { immCmWalletBuy } = this.props;
        const originFund = immCmWalletBuy.get('originFund');
        const step1 = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
        const isSelectedFund = step1.get('isSelectedFund');
        const missingTransferFundAmount = step1.get(
            'missingTransferFundAmount',
        );
        const isTransferWithMoney = step1.get('isTransferWithMoney');
        const buyType = immCmWalletBuy.get('buyType');
        const amount = { amount: missingTransferFundAmount, currency: 'EUR' };

        if (!isSelectedFund && !filteredFundsInfoEmpty) {
            return (
                <FormattedText value="brokerCM-brokerCM_buyStep1TraspassBuyInvalidFund" />
            );
        } else if (
            buyType === CM_BUY_TYPE_TRANSFER &&
            isTransferWithMoney &&
            originFund
        ) {
            return (
                <FormattedTextWithComponents
                    value="brokerCM-buyStep1TraspassBuyInvalidAmount"
                    className=""
                    injectedComponents={[
                        <OneLineSymbolAmount
                            amountObject={amount}
                            key="cmWalletBuyStep2AvailableAmount"
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(
                                amount,
                                true,
                            )}
                        />,
                    ]}
                />
            );
        }
    }

    buildWarningBox() {
        const titleWarningMessage = formatText(
            'brokerCM-brokerCM_buyStep1WarningBoxHeader',
        );

        this.props.disableNextButton();

        return (
            <div className="cm-buy-step1__warning-box">
                <OKMessage type="warning" title={titleWarningMessage}>
                    <div>
                        <FormattedText value="brokerCM-brokerCM_buyStep1WarningBoxFirstText" />
                        &nbsp;
                        <FormattedText value="brokerCM-brokerCM_buyStep1WarningBoxSecondText" />
                    </div>
                </OKMessage>
            </div>
        );
    }

    buildAdditionalAssociatedAccount() {
        const { immAccounts, immCmWalletBuy } = this.props;
        const step1 = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
        let warningBox;
        const accountsById = immAccounts.get('byId');
        const accountsIndexes = getCurrentAccounts(
            immAccounts.get('byOrder').toJS(),
            accountsById,
        );
        const originFundAssociatedAccount = step1.get('accountNumberTransfer');
        const missingTransferFundAmount = step1.get(
            'missingTransferFundAmount',
        );
        const selectedAccount = immAccounts.getIn([
            'byId',
            originFundAssociatedAccount,
        ]);
        const accountAmount = selectedAccount.getIn([
            'balances',
            'availableBalance',
            'amount',
        ]);
        const contractNumber = selectedAccount.get('newContractNumber');
        const productNumber = selectedAccount.get('newProduct');
        const oldFullContractNumber = selectedAccount.getIn([
            'ibanComplex',
            'codbban',
        ]);
        const mustChangeAccount = step1.get('mustChangeAccount');
        const detailsLabel = this.buildDetailsLabel(selectedAccount);
        const blockedAccountsIds = immAccounts.get('blockedAccountsIds');
        const isBlockedAccountsLoading = immAccounts.get(
            'blockedAccountsLoading',
        );

        if (mustChangeAccount) {
            this.props.onAccountChange(
                originFundAssociatedAccount,
                accountAmount,
                contractNumber,
                productNumber,
                oldFullContractNumber,
            );
            this.props.setAccountChanged();
        }

        if (missingTransferFundAmount > accountAmount) {
            warningBox = this.buildWarningBox();
        } else {
            this.props.enableNextButton();
        }

        return (
            <div>
                <div>
                    <FormattedText value="brokerCM-brokerCM_buyStep1TransferAdditionalLiquidityFirstText" />
                </div>
                <div>
                    <FormattedText value="brokerCM-brokerCM_buyStep1TransferAdditionalLiquiditySecondText" />
                </div>
                <div className="cm-buy-step1__additional-associated-cc-stocks-contracts">
                    <DropdownAccounts
                        id="broker-stocks-contracts"
                        immAccounts={accountsById}
                        blockedAccountsIds={blockedAccountsIds}
                        accountsIndexes={accountsIndexes}
                        currentAccountId={originFundAssociatedAccount}
                        initialAccountId={originFundAssociatedAccount}
                        showAvailableBalance
                        enabled={false}
                        loading={isBlockedAccountsLoading}
                    />
                </div>
                <span className="cm-buy-step1__associated-cc-legend">
                    {detailsLabel}
                </span>
                {warningBox}
            </div>
        );
    }

    handleFilterFundsByAccount(accountId) {
        const { immAccounts } = this.props;
        if (accountId.value) {
            const selectedAccount = immAccounts.getIn([
                'byId',
                accountId.value,
            ]);
            const associatedAccountNumber = selectedAccount.get(
                'contractNumber',
            );
            this.props.onFilterAccountChange(
                accountId.value,
                associatedAccountNumber,
            );
        } else {
            this.props.onFilterAccountChange(accountId.value, null);
        }
    }

    buildLabel(account) {
        const object = {
            amount: account.balances.availableBalance.amount,
            currency: account.balances.availableBalance.currency,
        };
        return (
            <span>
                {`${account.alias} ${getLastNChars(account.contractNumber)} - ${
                    account.catalogData.product
                } `}
                <strong>{`${buildAbsoluteFormattedValue(object)}`}</strong>
            </span>
        );
    }

    buildWalletFilter(walletFilterValue) {
        const { immCmWalletBuy } = this.props;
        const step1 = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
        let walletFilterDisabled = false;
        const TotalView = formatText(
            'brokerCM-brokerCM_customWalletsFilterPlaceholder',
        );
        const customWalletsFilterLabel = formatText(
            'brokerCM-brokerCM_customWalletsFilterLabel',
        );
        let walletsSelect = [
            {
                label: TotalView,
                value: CM_FILTERS_ALL_OPTIONS_VALUE,
            },
        ];
        const orderedWallets = sortBy(
            step1.get('customWallets').toJS(),
            wallet => wallet.descriptionPortfolioAccount.toLowerCase(),
        );
        orderedWallets.map(wallet => {
            walletsSelect.push({
                label: wallet.descriptionPortfolioAccount,
                value: wallet.idPortfolioAccount,
            });
        });

        if (orderedWallets.length === 0 && !step1.get('fetchingWallets')) {
            walletFilterDisabled = true;
        }

        return (
            <div className="cm-buy-step1__wallet-filter">
                <OKSelect
                    label={customWalletsFilterLabel}
                    placeholder={TotalView}
                    className="cm-buy-step1__associated-cc-stocks-contracts"
                    options={walletsSelect}
                    value={walletFilterValue}
                    onChange={this.handleWalletChange}
                    disabled={walletFilterDisabled}
                    clearable={false}
                    searchable={false}
                />
            </div>
        );
    }

    buildAssAccfilter(accountSelectedFromFilter) {
        const { immAccounts, immCmWalletBuy } = this.props;
        const AllAccountsOption = formatText(
            'brokerCM-brokerCM_associatedAccountFilterPlaceholder',
        );
        const dropdownLabel = formatText(
            'brokerCM-brokerCM_associatedAccountFilterLabel',
        );
        const dropdownPlaceholder = AllAccountsOption;
        const detailsLabel = accountSelectedFromFilter
            ? this.buildDetailsLabel(
                  immAccounts.get('byId').get(accountSelectedFromFilter),
              )
            : null;
        const selectionFundsInfoNotEmpty =
            immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_FIRST_STEP,
                'selectionFundsInfo',
            ]).size > 0;
        let assAccFilterDisabled = false;
        let accountsById = [];
        const validAccountsById = immAccounts
            .get('byId')
            .filter(account => account.getIn(['filters', 'valid']));
        const accountsIndexes = getCurrentAccounts(
            immAccounts.get('byOrder').toJS(),
            validAccountsById,
        );
        const filteredAccounts = immAccounts.get('byId').filter(account => {
            const accountsByIndex = accountsIndexes.filter(index => {
                return index === account.get('accountId');
            });
            return accountsByIndex.length > 0;
        });
        accountsById.push({
            label: AllAccountsOption,
            value: CM_FILTERS_ALL_OPTIONS_VALUE,
        });
        const orderedFilteredAccounts = sortBy(
            filteredAccounts.toJS(),
            account => account.balances.availableBalance.amount,
        );
        orderedFilteredAccounts.map(account => {
            const isBlocked = immAccounts
                .get('blockedAccountsIds')
                .includes(account.accountId);
            accountsById.push({
                label: this.buildLabel(account),
                value: account.accountId,
                icon: isBlocked ? 'icon-candado' : null,
                disabled: isBlocked,
            });
        });

        if (
            filteredAccounts.size === 1 &&
            !accountSelectedFromFilter &&
            selectionFundsInfoNotEmpty
        ) {
            const accountId = filteredAccounts.first().get('accountId');
            const selectedAccount = immAccounts.getIn(['byId', accountId]);
            const associatedAccountNumber = selectedAccount.get(
                'contractNumber',
            );
            this.props.onFilterAccountChange(
                accountId,
                associatedAccountNumber,
            );
        } else if (filteredAccounts.size === 1) {
            assAccFilterDisabled = true;
        }
        const content = immAccounts.get('blockedAccountsLoading') ? (
            <LoadingSection />
        ) : (
            <OKSelect
                label={dropdownLabel}
                placeholder={dropdownPlaceholder}
                name="advanced-search-product"
                className="cm-buy-step1__associated-cc-stocks-contracts"
                options={accountsById}
                value={accountSelectedFromFilter}
                onChange={this.handleFilterFundsByAccount}
                disabled={assAccFilterDisabled}
                clearable={false}
                searchable={false}
                showLabel={true}
            />
        );

        return (
            <div
                className={
                    accountSelectedFromFilter
                        ? 'cm-buy-step1__ass-acc-filter-expanded'
                        : 'cm-buy-step1__ass-acc-filter'
                }
            >
                {content}
                <span className="cm-buy-step1__associated-cc-legend">
                    {detailsLabel}
                </span>
            </div>
        );
    }

    buildTransferOriginContractsDetails() {
        const { immCmWalletBuy } = this.props;
        const step1 = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
        const isTransferWithMoney = step1.get('isTransferWithMoney');
        let selectionFundsInfo = step1.get('selectionFundsInfo');
        let originFund = immCmWalletBuy.get('originFund');
        const portfolio = immCmWalletBuy.getIn(['portfolios', 0]);
        const isFetchingContractsOriginTransfer = step1.get(
            'isFetchingContractsOriginTransfer',
        );
        const isContractsOriginTransferFetched = step1.get(
            'isContractsOriginTransferFetched',
        );
        const totalAmount = step1.get('amount');
        const selectionFundsInfoEmpty = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'selectionFundsInfoEmpty',
        ]);
        const walletFilterValue = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'walletFiltervalue',
        ]);
        const accountSelectedFromFilter = step1.get('accountNumberFromFilter');
        let filteredFundsInfoEmpty = false;
        let summary;
        let additionalAssociatedAccount;
        const filterTitle = (
            <FormattedText value="brokerCM-brokerCM_filtersTitle" />
        );
        const walletFilter = this.buildWalletFilter(walletFilterValue);
        const assAccfilter = this.buildAssAccfilter(accountSelectedFromFilter);
        selectionFundsInfo = selectionFundsInfo.filter(fund => {
            const isBlockedByRobo = fund.getIn([
                'infoFondosOutput',
                'infoFondosPosicionGlobal',
                'isBlockedByRobo',
            ]);
            return !isBlockedByRobo;
        });
        if (walletFilterValue && !accountSelectedFromFilter) {
            selectionFundsInfo = selectionFundsInfo.filter(fund => {
                const selectionFundsFiltered = fund
                    .getIn([
                        'infoFondosOutput',
                        'infoFondosPosicionGlobal',
                        'vistasPorCartera',
                    ])
                    .filter(wallet => {
                        return wallet === walletFilterValue.toString();
                    });
                return selectionFundsFiltered.size > 0;
            });
        } else if (!walletFilterValue && accountSelectedFromFilter) {
            selectionFundsInfo = step1.get('filteredFundsByAssociatedAccount');
        } else if (walletFilterValue && accountSelectedFromFilter) {
            selectionFundsInfo = step1.get('filteredFundsByAssociatedAccount');
            selectionFundsInfo = selectionFundsInfo.filter(fund => {
                const selectionFundsFiltered = fund
                    .getIn([
                        'infoFondosOutput',
                        'infoFondosPosicionGlobal',
                        'vistasPorCartera',
                    ])
                    .filter(wallet => {
                        return wallet === walletFilterValue.toString();
                    });
                return selectionFundsFiltered.size > 0;
            });
        }

        let willResetOriginFund;
        if (selectionFundsInfo.size === 0) {
            filteredFundsInfoEmpty = true;
            this.props.disableNextButton();
            willResetOriginFund = true;
        } else {
            const isOriginFundAvailable = selectionFundsInfo.filter(
                fund =>
                    fund.getIn([
                        'infoFondosOutput',
                        'infoFondosPosicionGlobal',
                        'contrato',
                        'numeroContrato',
                    ]) === originFund,
            );
            if (isOriginFundAvailable.size === 0) {
                willResetOriginFund = true;
            }
        }

        const fundTransferValidationWarning = this.buildFundTransferWarning(
            filteredFundsInfoEmpty,
        );

        if (isTransferWithMoney && !willResetOriginFund) {
            additionalAssociatedAccount = this.buildAdditionalAssociatedAccount();
        } else if (selectionFundsInfo.size > 0) {
            this.props.enableNextButton();
        }

        if (willResetOriginFund) {
            this.props.resetOriginFund();
        }

        if (
            isFetchingContractsOriginTransfer &&
            !isContractsOriginTransferFetched
        ) {
            summary = <LoadingSection />;
        } else {
            summary = (
                <CmTransferOriginContractsSummary
                    immAccounts={this.props.immAccounts}
                    selectionFundsInfoEmpty={selectionFundsInfoEmpty}
                    filteredFundsInfoEmpty={filteredFundsInfoEmpty}
                    selectionFundsInfo={selectionFundsInfo}
                    setOriginFund={this.props.setOriginFund}
                    saveOriginFundInfo={this.props.saveOriginFundInfo}
                    originFund={originFund}
                    totalAmount={totalAmount}
                    handleOnClick={this.onHandleWithMoneyClick}
                    portfolio={portfolio}
                    resetOriginFund={this.props.resetOriginFund}
                    saveOriginFundMatchedInPortfolio={
                        this.props.saveOriginFundMatchedInPortfolio
                    }
                />
            );
        }

        return (
            <div className="cm-buy-step1__transfer-origin-contracts-details-box cm-buy-step1__funds-details-box">
                <h2 className="cm-buy-step1__transfer-origin-contracts-title">
                    <FormattedText value="brokerCM-buyStep1transferOriginContractsTitle" />
                </h2>
                <div className="cm-buy-step1__filters">
                    <div className="cm-buy-step1__filters-subtitle">
                        {filterTitle}
                    </div>
                    {walletFilter}
                    {assAccfilter}
                </div>
                <div>
                    <div className="cm-buy-step1__transfer-origin-contracts-summary-wrapper">
                        {summary}
                    </div>
                    <div className="cm-buy-step1__invalid-amount-error">
                        {fundTransferValidationWarning}
                    </div>
                    {additionalAssociatedAccount}
                </div>
            </div>
        );
    }

    handleFromOtherFundsClick() {
        this.props.setBuyType(CM_BUY_TYPE_TRANSFER);
        this.props.getPortfolioList();
        return this.props.getContractsAsOriginTransfer(this.props.history);
    }

    onHandleWithMoneyClick() {
        this.props.setBuyType(CM_BUY_TYPE_MONEY);
    }

    getBuyTypeButtonClass(type, notAmount) {
        const buyType = this.props.immCmWalletBuy.get('buyType');
        return classnames('additional-action-secondary ', {
            'buttons-base buttons-base--active': buyType === type,
            'buttons-base buttons-base--regular':
                buyType !== type && !notAmount,
            'buttons-base buttons-base--regular--disabled':
                buyType !== type && notAmount,
        });
    }

    buildBuyTypeButtons() {
        const { flagBasedFeatures, immCmWalletBuy } = this.props;
        const notAmount =
            immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP, 'amount']) ===
            0;
        let informativeText;
        let transferButton;

        if (notAmount) {
            informativeText = (
                <span className="cm-buy-step1__buy-type-informative-text">
                    <FormattedText value="brokerCM-brokerCM_buyStep1TransferDisabledInformativeText" />
                </span>
            );
        }

        if (flagBasedFeatures.get('wealth-cm-traspass-enabled')) {
            transferButton = (
                <span>
                    <button
                        onClick={() => this.handleFromOtherFundsClick()}
                        className={this.getBuyTypeButtonClass(
                            CM_BUY_TYPE_TRANSFER,
                            notAmount,
                        )}
                        disabled={notAmount}
                    >
                        <FormattedText value="brokerCM-buyStep1BuyFromOtherFundsOption" />
                    </button>
                    {informativeText}
                </span>
            );
        }

        return (
            <FeatureTogglingRender
                notAllowedProductKey={DIVERSIFIED_INVESTMENT_FUNDTRANSFER}
            >
                <div className="cm-buy-step1__buy-type">
                    <div className="cm-buy-step1__buy-type-title">
                        <FormattedText value="brokerCM-buyStep1BuyTypeTitle" />
                    </div>
                    <h4 className="cm-buy-step1__buy-type-subtitle">
                        <FormattedText value="brokerCM-buyStep1BuyTypeSubtitle" />
                    </h4>
                    <div
                        id="buyButtonTypeSelection"
                        className="cm-buy-step1__buy-type-buttons-section"
                    >
                        <button
                            onClick={() => this.onHandleWithMoneyClick()}
                            className={this.getBuyTypeButtonClass(
                                CM_BUY_TYPE_MONEY,
                            )}
                        >
                            <FormattedText value="brokerCM-buyStep1BuyWithMoneyOption" />
                        </button>
                        {transferButton}
                    </div>
                </div>
            </FeatureTogglingRender>
        );
    }

    render() {
        const { immCmWalletBuy } = this.props;
        const title = formatText('brokerCM-buyStep1Title');
        const portfolio = immCmWalletBuy.getIn(['portfolios', 0]);
        const accountsContainer = this.buildAccountContainer();
        const buyTypeButtons = this.buildBuyTypeButtons();
        const showGeneralMinAmountMessage = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'showGeneralMinAmountMessage',
        ]);
        const isFetchingPortfolioInfo = immCmWalletBuy.get(
            'isFetchingPortfolioInfo',
        );
        const fundsDetailsBlock = this.buildFundsDetails(
            portfolio,
            showGeneralMinAmountMessage,
            isFetchingPortfolioInfo,
        );
        const link = formatText(
            'disclaimerPersonalInfo-cmGdprDisclaimerLinkUrl',
        );
        let transferOriginContractsDetails;

        if (immCmWalletBuy.get('buyType') === CM_BUY_TYPE_TRANSFER) {
            transferOriginContractsDetails = this.buildTransferOriginContractsDetails();
        } else {
            this.props.enableNextButton();
        }

        return (
            <div className="cm-buy-step1 clearfix">
                <header className="cm-buy-step1__header">
                    <h2 className="cm-buy-step1__title">{title}</h2>
                </header>
                <div className="row">
                    <div className="col-lg-12">{fundsDetailsBlock}</div>
                </div>
                {buyTypeButtons}
                {transferOriginContractsDetails}
                {accountsContainer}
                <OKMessage type="informative" modifier="dark-bg">
                    <FormattedText value="disclaimerPersonalInfo-cmGdprDisclaimerText" />
                    &nbsp;
                    <OKLink to={link} target="_blank" inverse={true}>
                        <FormattedText value="disclaimerPersonalInfo-cmGdprDisclaimerLinkText" />
                    </OKLink>
                </OKMessage>
            </div>
        );
    }
}

CmWalletBuyStep1.propTypes = {
    history: PropTypes.object.isRequired,
    immCmWalletBuy: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    onAccountChange: PropTypes.func,
    setAccount: PropTypes.func,
    disableNextButton: PropTypes.func,
    enableNextButton: PropTypes.func,
    onLegalDocumentClick: PropTypes.func.isRequired,
    onSetAmount: PropTypes.func,
    onSetInitialAmount: PropTypes.func,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    getPortfolioInfo: PropTypes.func,
    getContractsAsOriginTransfer: PropTypes.func,
    setBuyType: PropTypes.func,
    setOriginFund: PropTypes.func,
    saveOriginFundInfo: PropTypes.func,
    setAccountChanged: PropTypes.func,
    fetchFeatureFlag: PropTypes.func,
    flagBasedFeatures: PropTypes.object,
    onFilterAccountChange: PropTypes.func,
    getPortfolioList: PropTypes.func,
    onWalletChange: PropTypes.func,
    resetOriginFund: PropTypes.func,
    saveOriginFundMatchedInPortfolio: PropTypes.func,
};

module.exports = withRouter(CmWalletBuyStep1);
